import React from 'react'
import IMG from '../IMG/VLAD.jpeg'

function About() {
  return (
    <>
      <div id="About">
        <div className="Heading pt-12 pb-24">
          <div className="container flex flex-col justify-center items-center space-y-7 md:space-y-10">
            <h2 data-aos="zoom-in" className='pt-16'>About <span className='span2'>Me.</span></h2>
            <img data-aos="zoom-in" src={IMG} alt="Noman" className='select-none max-w-80' />
            <h1 data-aos="zoom-in" className='font-medium text-3xl xl:text-6xl lg:text-6xl md:text-6xl sm:text-5xl xsm:ps-0 xsm:text-4xl'><span>Front-End</span> Developer!</h1>
            <p data-aos="zoom-in">Hello, I am a FrontEnd Web Developer. I can supply you with visual, interactive website pieces that are responsive to all devices. I guarantee that the website I create will be responsive, easy to maintain, and well-structured. I am passionate about my work. I consistently strive to meet the needs of my customers, and my specialties include paying close attention to detail and being on time. <br />If you have any questions, please contact me, and I would be pleased to answer them.</p>
            <p>" <span>I never dreamed about success, I worked for it.</span>"</p>
            <a href='/about' target='_blank' className="btn3 pt-[10px]">Read More</a>
          </div>
        </div>
      </div>
    </>
  )
}

export default About
